const CopyRevert = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7084 7.2915V3.33317C12.7084 2.75787 12.242 2.2915 11.6667 2.2915H3.33335C2.75806 2.2915 2.29169 2.75787 2.29169 3.33317V11.6665C2.29169 12.2418 2.75806 12.7082 3.33335 12.7082H7.29169M8.33335 7.2915H16.6667C17.242 7.2915 17.7084 7.75787 17.7084 8.33317V16.6665C17.7084 17.2418 17.242 17.7082 16.6667 17.7082H8.33335C7.75806 17.7082 7.29169 17.2418 7.29169 16.6665V8.33317C7.29169 7.75787 7.75806 7.2915 8.33335 7.2915Z"
        stroke="#1448CB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CopyRevert
